<template>
	<div class="cc">
		<userMenu></userMenu>
		<div class="cc-box" style="display: block;">
			<div class="cc-head">
				<el-tag type="success" effect="plain">我的提示词</el-tag>
				<el-input v-model="input" placeholder="输入关键字搜索" size="small" style="width: 200px;margin-left: 40px;margin-right:5px;"></el-input>
				<el-button type="primary" size="small" icon="el-icon-search">搜索</el-button>
				<el-button type="success" size="small" style="position: absolute;right: 30px;" icon="el-icon-plus" @click="drawer=true">发提示词</el-button>
			</div>
			<div class="cc-list">
				<div class="cc-table">
					<div class="cc-tab1">序</div>
					<div class="cc-tab2">标题</div>
					<div class="cc-tab3">状态</div>
					<div class="cc-tab4">类目</div>
					<div class="cc-tab5">发布时间</div>
					<div class="cc-tab6">操作</div>
				</div>
				<div class="word-list">
					<ul>
						<li v-for="(item,index) in listData">
							<div class="cc-tab1">
								<div class="word-no">
									{{index+1<10?'0'+(index+1):index+1}}
								</div>
							</div>
							<div class="cc-tab2">
								<div class="word-tit">
									{{item.title}}
								</div>
							</div>
							<div class="cc-tab3">
								<el-tag size="small" type="danger" v-if="item.audit==0">待审核</el-tag>
								<el-tag size="small" type="success" v-if="item.audit==1">已上线</el-tag>
								<el-tag size="small" type="warning" v-if="item.audit==2">未通过</el-tag>
							</div>
							<div class="cc-tab4">
								{{getCatName2(item.pid,item.cate_id)}}
							</div>
							<div class="cc-tab5">
								{{item.create_time}}
							</div>
							<div class="cc-tab6">
								<el-button type="success" size="mini" v-if="item.audit!=1">编辑</el-button>
								<el-button type="info" size="mini" v-else>编辑</el-button>
								<el-button type="danger" size="mini">删除</el-button>
							</div>
						</li>
					</ul>
				</div>
				<div class="word-paeg" v-if="total>0">
					<el-pagination @current-change="nextPage" background :current-page="page" :page-size="rows" layout="total,prev, pager, next"
					 :total="total"></el-pagination>
				</div>
			</div>
			
			<el-drawer title="发布提示词" :visible.sync="drawer" direction="rtl" size="700px">
				<div class="cc-send" v-loading="loading" element-loading-text="发布中...">
					<div class="cc-title">
						创作中心 - 发布提示词
					</div>
					<el-form label-width="80px" size="small">
						<el-form-item label="发布栏目">
							<el-cascader style="width: 100%;" placeholder="请选择栏目" v-model="catids" :options="catData" :props="{ expandTrigger: 'hover' }"></el-cascader>
						</el-form-item>
						<el-form-item label="词话标题">
							<el-input v-model="title" placeholder="请输入提示词的标题"></el-input>
						</el-form-item>
						<el-form-item label="图片地址">
							<el-input v-model="pic" placeholder="请输入提示词的图片地址"></el-input>
						</el-form-item>
						<el-form-item label="中文词话">
							<el-input v-model="cn" type="textarea" rows="10" placeholder="请输入提示词的中文详情"></el-input>
						</el-form-item>
						<el-form-item label="英文词话">
							<el-input v-model="en" type="textarea" rows="10" placeholder="请输入提示词的英文详情"></el-input>
						</el-form-item>
						<el-form-item label="适用场景">
							<el-input v-model="tag" placeholder="多个适用场景请用、分隔开"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" style="width: 200px;margin: 20px 0 20px 130px;" size="medium" @click="save">立即发布</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-drawer>
		</div>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				title: '',
				pic: '',
				cn: '',
				en: '',
				tag: '',
				catData:[],
				catids:'',
				loading:false ,
				copyTxt:'',
				page:1,
				rows:10,
				listData:[],
				total:0,
				drawer:false
			}
		},
		methods:{
			nextPage(val){
				this.page = val;
				this.getWordList();
			},
			getWordList(){
				let params = {
					token: api.getCookie('token'),
					page:this.page,
					rows:this.rows
				}
				api.getListByUser(params).then(res=>{
					if(res.code==200){
						this.listData = res.data.list;
						this.total = parseInt(res.data.total);
					}
				})
			},
			getCatName(pid){
				let data = this.catData;
				for(let i in data){
					if(data[i].value == pid){
						return data[i].label;
					}
				}
			},
			getCatName2(pid,cid){
				let data = this.catData;
				for(let i in data){
					if(data[i].value == pid){
						for(let j in data[i].children){
							if(data[i].children[j].value == cid){
								return data[i].children[j].label;
							}
						}
					}
				}
			},
			save(){
				if(this.catids==''){
					this.$message.error('请选择栏目');
					return
				}
				if(this.title==''){
					this.$message.error('请输入标题');
					return
				}
				if(this.pic==''){
					this.$message.error('请输入图片地址');
					return
				}
				if(this.cn==''){
					this.$message.error('请输入中文提示词');
					return
				}
				/* if(this.en==''){
					this.$message.error('请输入英文文提示词');
					return
				} */
				if(this.tag==''){
					this.$message.error('请输入适用场景');
					return
				}
				let params = {
					pid: this.catids[0],
					cid: this.catids[1],
					title: this.title,
					pic: this.pic,
					cn: this.cn,
					en: this.en,
					tag: this.tag
				}
				this.loading = true;
				api.saveInfo(params).then(res => {
					if (res.code == 200) {
						this.loading = false;
						this.title = '';
						this.en = '';
						this.cn = '';
						this.tag = '';
						this.$message.success('保存成功');
					}
				})
			},
			parsePromptText() {
				let text = this.copyTxt;
				const lines = text.split('\n').filter(line => line.trim() !== '');
				
				let tt = lines[0].split('、');
				if(tt.length==2){
					this.title = tt[1];
				}else{
					this.title = tt[0];
				}
				this.pic = 'http://cai.beiyv.com/ai/'+this.catids[1]+'/'+tt[0]+'.jpg';
				this.cn = lines[1].split('：')[1];
				this.en = lines[2].split('：')[1];
				this.tag = lines[3].split('：')[1];
			},
			getCategoryList(){
				api.getCategoryList({}).then(res=>{
					let data = res.data;
					let arry = [];
					for(let i in data){
						let obj = {
							value: data[i].id,
							label: data[i].name,
							children:[]
						}
						for(let j in data[i].children){
							let obj2 = {
								value: data[i].children[j].id,
								label: data[i].children[j].name,
							}
							obj.children.push(obj2)
						}
						arry.push(obj)
					}
					this.catData = arry;
				})
			}
		},
		created() {
			this.getCategoryList();
			this.getWordList();
		}
	}
</script>

<style>
	.cc-tab1{
		width: 50px;
		text-align: left;
	}
	.cc-tab2{
		flex: 1;
		text-align: left;
	}
	.cc-tab3{
		width: 100px;
		text-align: center;
	}
	.cc-tab4{
		width: 200px;
		font-size: 14px;
		text-align: center;
	}
	.cc-table{
		display: flex;
		font-size: 14px;
		text-align: center;
		color: #999;
		padding: 0 20px 10px 20px;
	}
	.cc-tab5{
		width: 180px;
		font-size: 14px;
		text-align: center;
	}
	.cc-tab6{
		width: 150px;
		text-align: center;
	}
	.cc-head{
		display: flex;
		align-items: center;
		width: 100%;
		height: 60px;
		padding: 0 30px;
		box-sizing: border-box;
		background-color: #fff;
	}
	.word-paeg {
		padding: 20px 0;
		text-align: center;
	}
	.word-btn{
		position: absolute;
		right: 0;
		top: 27px;
	}
	.word-tit span{
		position: relative;
		top: -2px;
	}
	.word-bom{
		font-size: 12px;
		padding-left: 30px;
		padding-top: 5px;
		color: #666;
	}
	.word-tit{
		
	}
	.word-no{
		position: relative;
		top: -1px;
		font-size: 19px;
		font-family: 'numfont';
		width: 30px;
		color: #ddd;
	}
	.word-top{
		display: flex;
		line-height: 20px;
	}
	.cc-title{
		display: none;
		font-size: 17px;
		color: #000;
		padding-bottom: 20px;
		text-align: right;
	}
	.cc-box {
		padding-left: 220px;
	}

	.cc-list {
		flex: 1;
		padding: 20px;
		box-sizing: border-box;
	}

	.cc-send {
		width: 600px;
		min-height: 100vh;
		background-color: #fff;
		padding: 30px;
		box-sizing: border-box;
	}
	.word-list{
		width: 100%;
		border-radius: 10px;
	}
	.word-list ul{
		margin: 0;
		padding: 0;
	}
	.word-list ul li{
		display: flex;
		position: relative;
		align-items: center;
		margin: 0;
		padding: 18px 20px;
		box-sizing: border-box;
		background-color: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
	}
	.cc {
		width: 100%;
		min-height: 100vh;
		background-color: var(--bg3);
	}
	.cc-list-item{
		padding: 20px;
		background-color: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/page/word.vue